export enum RiskLevel {
    Alert = 'Alert',
    Critical = 'Critical',
    High = 'High',
    Medium = 'Medium',
    Low = 'Low',
    Safe = 'Safe'
}

export const RISKS = [
    RiskLevel.Alert,
    RiskLevel.Critical,
    RiskLevel.High,
    RiskLevel.Medium,
    RiskLevel.Low,
    RiskLevel.Safe
];

export const RISK_FILTER_ORDER = [
    RiskLevel.Alert,
    RiskLevel.Critical,
    RiskLevel.High,
    RiskLevel.Medium,
    RiskLevel.Low,
    RiskLevel.Safe
];

/* eslint-disable sort-keys-fix/sort-keys-fix */
export const TRANSLATERISKS = {
    undefined: -3,
    Safe: -2,
    Low: 0,
    Medium: 1,
    High: 2,
    Critical: 3,
    Alert: 4
};

export enum TranslateRisk {
    UNDEFINED = 'undefined',
    SAFE = 'Safe',
    LOW = 'Low',
    MEDIUM = 'Medium',
    HIGH = 'High',
    CRITICAL = 'Critical',
    ALERT = 'Alert'
}
